<template>
  <div class="content-warp">
    <a-row :gutter="24">
      <a-col :span="6">
        <div class="content-panle bg-white" style="height:670px">
          <SingleTreeWithSearch
            ref="treeArea"
            :selectedData="targetOrg"
            :mixNodeName="false"
            @update:selectedOrg="handleSelectedOrg"
          ></SingleTreeWithSearch>
        </div>
      </a-col>

      <a-col :span="18">
        <div class="content-panle bg-white">
          <div class="table-operation-area">
            <div class="btn-area-inline">
              <a-button
                type="primary"
                :disabled="!targetOrg"
                @click="handleShowAddModal"
                >{{ $t('devicesMana.addBtn') }}</a-button
              >
              <a-button
                type="primary"
                :disabled="!selectedRowKeys.length"
                @click="handleToSetActiveTime"
                >{{ $t('devicesMana.activeTimeBtn') }}</a-button
              >
              <a-button
                type="danger"
                :disabled="!selectedRowKeys.length"
                @click="handleDeleteDevices"
                >{{ $t('devicesMana.deleteBtn') }}</a-button
              >
            </div>
            <a-form
              class="search-form"
              layout="inline"
              :form="listSearchForm"
              @submit.prevent="handleSearch"
            >
              <a-form-item>
                <a-select
                  dropdownClassName="form-select"
                  :getPopupContainer="trigger => trigger.parentNode"
                  style="width: 150px"
                  :disabled="!targetOrg"
                  :placeholder="$t('devicesMana.deviceTypesTxt')"
                  :options="searchTypesOptions"
                  v-decorator="['searchType']"
                />
              </a-form-item>
              <a-form-item>
                <a-select
                  dropdownClassName="form-select"
                  :getPopupContainer="trigger => trigger.parentNode"
                  style="width: 150px"
                  :disabled="!targetOrg"
                  :placeholder="$t('devicesMana.deviceStatusTxt')"
                  :options="searchStatusOptions"
                  v-decorator="['searchStatus']"
                />
              </a-form-item>
              <a-form-item>
                <a-input
                  style="width: 150px"
                  :disabled="!targetOrg"
                  type="text"
                  v-decorator="['searchSNOrName']"
                  :placeholder="$t('devicesMana.deviceSNOrNameTxt')"
                >
                  <a-icon
                    slot="prefix"
                    type="setting"
                    style="color:rgba(0,0,0,.25)"
                  />
                </a-input>
              </a-form-item>
              <a-form-item>
                <a-button
                  type="primary"
                  html-type="submit"
                  :disabled="!targetOrg"
                  :loading="targetOrg && loading"
                >
                  {{ $t('devicesMana.searchBtn') }}
                </a-button>
              </a-form-item>
            </a-form>
          </div>
          <TableTips
            :total="pagination.total"
            :selected="selectedRowKeys.length"
            @clearAllSelected="
              () => {
                selectedRowKeys = []
                selectedRowItems = []
              }
            "
          />
          <a-table
            class="table-area"
            :rowSelection="{
              selectedRowKeys: selectedRowKeys,
              onChange: handleTableItemSelected
            }"
            :scroll="{ x: 1200 }"
            :columns="tableColumns"
            :dataSource="tableData"
            :pagination="pagination"
            :loading="loading"
            @change="handleTableChange"
          >
            <template slot="status" slot-scope="text, record">
              <a-tag v-if="record.statusCode === 1" color="green">{{
                text
              }}</a-tag>
              <a-tag v-else-if="record.statusCode === 2" color="red">{{
                text
              }}</a-tag>
              <a-tooltip v-else placement="rightBottom">
                <a-tag color="red" style="cursor:pointer">{{ text }}</a-tag>
                <template slot="title">
                  <p style="margin:0;max-width:200px;">
                    {{ record.errorMessage }}
                  </p>
                </template>
              </a-tooltip>
            </template>

            <template slot="operation" slot-scope="text, record">
              <div v-if="record.operation">
                <a
                  class="operation-botton"
                  :disabled="record.operation[0].disabled"
                  :style="{ color: record.operation[0].color || '#1890ff' }"
                  @click="record.operation[0].callback(record)"
                >
                  {{ $t(record.operation[0].type) }}
                </a>

                <a-dropdown>
                  <a-menu slot="overlay">
                    <a-menu-item
                      @click="
                        e => {
                          handleSendCommand(e, record.id, 5001)
                        }
                      "
                      ><a>{{
                        $t('devicesMana.remoteOpenDoor')
                      }}</a></a-menu-item
                    >
                    <a-menu-item
                      @click="
                        e => {
                          handleSendCommand(e, record.id, 5002)
                        }
                      "
                      ><a>{{
                        $t('devicesMana.remoteCloseDoor')
                      }}</a></a-menu-item
                    >
                    <a-menu-item
                      @click="
                        e => {
                          handleSendCommand(e, record.id, 5004)
                        }
                      "
                      ><a>{{ $t('devicesMana.normallyOpen') }}</a></a-menu-item
                    >
                    <a-menu-item
                      @click="
                        e => {
                          handleSendCommand(e, record.id, 5003)
                        }
                      "
                      ><a>{{ $t('devicesMana.reboot') }}</a></a-menu-item
                    >
                  </a-menu>
                  <a
                    class="operation-botton"
                    :disabled="record.operation[1].disabled"
                    :style="{ color: record.operation[1].color || '#1890ff' }"
                  >
                    {{ $t(record.operation[1].type) }}
                  </a>
                </a-dropdown>
              </div>
            </template>
          </a-table>
        </div>
      </a-col>
    </a-row>

    <!-- 新增设备模态框 -->
    <a-modal
      :title="addModalTitleStr"
      :visible="addDeviceModalVisible"
      :okText="$t('devicesMana.confirmBtn')"
      :cancelText="$t('devicesMana.cancelBtn')"
      @ok="handleAddDevice"
      :confirmLoading="confirmDeviceLoading"
      @cancel="
        () => {
          addDeviceModalVisible = false
        }
      "
      :afterClose="handleHideAddModal"
    >
      <a-form-model
        ref="addDeviceForm"
        :model="addDeviceForm"
        :rules="addDeviceFormRules"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 18 }"
      >
        <a-form-model-item
          required
          :label="$t('devicesMana.deviceSN')"
          prop="SN"
        >
          <a-input
            v-model="addDeviceForm.SN"
            :placeholder="$t('devicesMana.deviceSNTxt')"
          />
        </a-form-model-item>
        <a-form-model-item
          required
          :label="$t('devicesMana.deviceType')"
          prop="type"
        >
          <a-select
            :options="enumsData.deviceType"
            v-model="addDeviceForm.type"
          />
        </a-form-model-item>
        <a-form-model-item
          required
          :label="$t('devicesMana.deviceName')"
          prop="name"
        >
          <a-input
            v-model="addDeviceForm.name"
            :placeholder="$t('devicesMana.deviceNameTxt')"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import SingleTreeWithSearch from '@/components/SingleTreeWithSearch'
import TableTips from '@/components/TableTips'
import { mapState } from 'vuex'
import { parsePromiseAllRes, deleteSelectedRow } from '../../utils/utils'
import {
  getDevices,
  createDevice,
  deleteDevice,
  sendRemoteCommand
} from '@/api/deviceMana'

export default {
  name: 'devicesManaIndex',
  components: {
    SingleTreeWithSearch,
    TableTips
  },
  data() {
    return {
      targetOrg: null, // 组织树中选中的对象

      listSearchForm: this.$form.createForm(this),
      searchTypesOptions: [],
      searchStatusOptions: [],

      loading: false, // 列表内容是否在加载中
      tableData: [], // 列表数据源
      tableColumns: this.getTableColumns(), // 列表表头项
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      selectedRowKeys: [], // 列表多选钩中项的Id数组
      selectedRowItems: [], // 列表多选钩中项的数组
      selectedHasVMachine: false, // 列表多选钩中项是否包含访客一体机
      // 添加设备
      addModalTitleStr: '',
      addDeviceModalVisible: false,
      modalDeviceDeptName: '',
      confirmDeviceLoading: false,

      addDeviceForm: {
        SN: '',
        type: '',
        name: ''
      },
      addDeviceFormRules: this.getAddDeviceFormRules()
    }
  },
  computed: {
    ...mapState({
      lang: 'lang',
      enumsData: state => state.enumsStore.enumsData
    })
  },
  watch: {
    lang: function(lang) {
      this.tableColumns = this.getTableColumns()
      this.addDeviceFormRules = this.getAddDeviceFormRules()
    }
  },
  created() {
    const { onlineState, deviceType } = this.enumsData
    this.onlineStateMap = {}
    onlineState.forEach(item => {
      this.onlineStateMap[item.value] = item.title
    })
    this.deviceTypeNames = {}
    deviceType.forEach(type => {
      this.deviceTypeNames[type.value] = type.title
    })

    this.searchStatusOptions = [].concat(
      [
        {
          title: this.$t('devicesMana.deviceStatusAllOption'),
          value: '',
          key: 'all'
        }
      ],
      onlineState
    )
    this.searchTypesOptions = [].concat(
      [
        {
          title: this.$t('devicesMana.deviceStatusAllOption'),
          value: '',
          key: 'all'
        }
      ],
      deviceType
    )
  },
  activated() {
    this.getDevicesListData()
  },
  methods: {
    getTableColumns() {
      return [
        {
          fixed: 'left',
          title: this.$t('devicesMana.listName'),
          dataIndex: 'name',
          width: 160
        },
        {
          title: this.$t('devicesMana.listSN'),
          dataIndex: 'SN',
          width: 120
        },
        {
          title: this.$t('devicesMana.listType'),
          dataIndex: 'typeName',
          width: 100
        },
        {
          title: this.$t('devicesMana.listStatus'),
          dataIndex: 'status',
          width: 100,
          scopedSlots: { customRender: 'status' }
        },
        {
          title: this.$t('devicesMana.listCloudPlatformExpiredAt'),
          dataIndex: 'cloudPlatformExpiredAt',
          width: 120,
        },
        {
          title: this.$t('devicesMana.listIotCardExpiredAt'),
          dataIndex: 'iotCardExpiredAt',
          width: 120,
        },
        {
          title: this.$t('devicesMana.listVersion'),
          dataIndex: 'version',
          width: 80,
        },
        {
          title: this.$t('devicesMana.listPersonCount'),
          dataIndex: 'personCount',
          width: 100,
        },
        {
          fixed: 'right',
          width: 140,
          title: this.$t('devicesMana.listOperation'),
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' }
        }
      ]
    },
    getAddDeviceFormRules() {
      return {
        SN: [
          {
            required: true,
            message: this.$t('devicesMana.deviceSNBlank'),
            trigger: ['blur', 'change']
          }
        ],
        name: [
          {
            required: true,
            message: this.$t('devicesMana.deviceNameBlank'),
            trigger: ['blur', 'change']
          },
          {
            max: 20,
            message: this.$t('devicesMana.deviceNameWarning'),
            trigger: ['blur', 'change']
          }
        ]
      }
    },

    // 选定一个组织
    handleSelectedOrg(data) {
      // console.log('-------handleSelectedOrg--------', data);
      this.targetOrg = data
      this.modalDeviceDeptName = data.nameList.join(' / ')
      this.pagination.current = 1
      deleteSelectedRow(undefined, this.selectedRowKeys, this.selectedRowItems)
      this.getDevicesListData()
    },

    // 搜索列表
    handleSearch() {
      this.listSearchForm.validateFields(async (err, values) => {
        if (!err) {
          this.pagination.current = 1
          deleteSelectedRow(
            undefined,
            this.selectedRowKeys,
            this.selectedRowItems
          )
          this.getDevicesListData(1, values)
        }
      })
    },

    // 获取设备列表数据
    async getDevicesListData(page, data = {}) {
      try {
        this.loading = true
        const res = await getDevices({
          deptId: this.targetOrg.id,
          perPage: this.pagination.pageSize,
          page: page || this.pagination.current,
          searchChildren: false, // 不查询子组织的设备
          keyword: data.searchSNOrName && data.searchSNOrName.trim(),
          deviceTypes: [data.searchType],
          onlineState: data.searchStatus
        })
        this.loading = false

        this.tableData = this.createDeviceTableData(res.data.collection)
        this.pagination.total = res.data.size
      } catch (error) {
        this.loading = false
      }
    },
    createDeviceTableData(data) {
      return data.map(item => {
        return {
          key: item.id,
          id: item.id,
          SN: item.deviceSn,
          name: item.deviceName,
          type: item.deviceTypeCode,
          typeName: this.deviceTypeNames[item.deviceTypeCode],
          status: this.onlineStateMap[item.deviceOnlineState],
          statusCode: item.deviceOnlineState,
          errorMessage: item.errorMessage,
          doorState: item.doorState,
          version: item.softVer,
          personCount: item.authCount,
          deptName: item.deptFullName,
          cloudPlatformExpiredAt: item.cloudPlatformExpiredAt,
          iotCardExpiredAt: item.iotCardExpiredAt,
          deptid: item.deptId,
          signIn: item.isVisitorSignAcDevice,
          operation: [
            {
              type: 'devicesMana.listConfigBtn',
              disabled: false,
              color: '#fa8c16',
              callback: this.handleToDeviceConfig,
              dropdown: false
            },
            {
              type: 'devicesMana.listMoreBtn',
              disabled: item.deviceTypeCode !== 101,
              color: '',
              callback: '',
              dropdown: true
            }
          ]
        }
      })
    },
    // 点击分页时触发
    handleTableChange(pagination, filters, sorter) {
      // console.log('-------handleTableChange------', pagination);
      this.pagination.current = pagination.current
      this.getDevicesListData()
    },
    // table项勾选
    handleTableItemSelected(rowKeys, rowItems) {
      // console.log(rowKeys, rowItems)
      this.selectedRowKeys = rowKeys
      this.selectedRowItems = rowItems
      // 判断选中的项是否包含访客一体机
      this.selectedHasVMachine = rowItems.some(item => item.type === 102)
    },

    // 发送远程指令
    async handleSendCommand(e, id, type) {
      try {
        let commandType
        switch (type) {
          case 5001:
            commandType = this.$t('devicesMana.remoteOpenDoor')
            break
          case 5002:
            commandType = this.$t('devicesMana.remoteCloseDoor')
            break
          case 5003:
            commandType = this.$t('devicesMana.reboot')
            break
          case 5004:
            commandType = this.$t('devicesMana.normallyOpen')
            break
          default:
            break
        }
        const sendingTips = new Function(
          'command',
          this.$t('devicesMana.sendingTips')
        )(commandType)
        this.$message.loading(sendingTips, 0)

        await sendRemoteCommand({
          id: id,
          commandType: type,
          commandParam: ''
        })
        this.$message.destroy()
        this.$notification.success({
          message: this.$t('devicesMana.sendRemoteCommandSuccess')
        })
      } catch (error) {
        this.$message.destroy()
      }
    },
    // 进入设备配置页面
    handleToDeviceConfig(device) {
      // console.log(device)
      const {
        SN,
        name,
        deptName,
        deptid,
        id,
        status,
        version,
        personCount,
        type,
        typeName,
        signIn
      } = device
      this.$router.push({
        path: '/devices-mana/config',
        query: {
          SN,
          name,
          deptName,
          deptid,
          id,
          status,
          version,
          personCount,
          type,
          typeName,
          signIn
        }
      })
    },

    // 批量设置门禁有效时间
    handleToSetActiveTime() {
      if (this.selectedHasVMachine) {
        this.$confirm({
          width: 550,
          title: this.$t('devicesMana.batchSetTimeWarnTitle'),
          content: this.$t('devicesMana.batchSetTimeWarnDesc'),
          okType: 'primary',
          okText: this.$t('devicesMana.continueBtn'),
          cancelText: this.$t('devicesMana.cancelBtn'),
          onOk: () => {
            const selected = [].concat(this.selectedRowItems)
            selected.forEach((item, index) => {
              if (item.type === 102) {
                this.selectedRowKeys.splice(index, 1)
                this.selectedRowItems.splice(index, 1)
              }
            })
            this.toSetActiveTimePage()
          }
        })
      } else {
        this.toSetActiveTimePage()
      }
    },
    toSetActiveTimePage() {
      const queryData = this.selectedRowItems.map(item => {
        const { id, name, deptName } = item
        return { id, name, deptName }
      })
      queryData.length &&
        this.$router.push({
          path: '/devices-mana/active-time',
          query: {
            ds: JSON.stringify(queryData)
          }
        })
    },

    // 批量删除设备
    handleDeleteDevices() {
      this.$confirm({
        title: new Function('count', this.$t('devicesMana.deleteWarning'))(
          this.selectedRowKeys.length
        ),
        content: this.$t('devicesMana.deleteWarningDesc'),
        okText: this.$t('devicesMana.confirmBtn'),
        cancelText: this.$t('devicesMana.cancelBtn'),
        onOk: () => {
          this.deleteDeviceRquest(this.selectedRowKeys)
        },
        onCancel() {}
      })
    },
    // 删除设备
    deleteDeviceRquest(idsArr) {
      const deletePromises = idsArr.map(item => this.getDeleteDeviceAxios(item))
      Promise.all(deletePromises)
        .then(resArr => {
          // 处理 Promise.all 返回结果
          const { successRes } = parsePromiseAllRes(this, resArr, {
            successMsg: new Function(
              'count',
              this.$t('devicesMana.batchDeleteSuccess')
            ),
            failMsg: new Function(
              'count',
              this.$t('evicesMana.bacthDeleteFail')
            ),
            targets: this.selectedRowItems.map(item => {
              return { id: item.id, name: item.name }
            })
          })

          // 有删除成功的结果，则刷新列表
          if (successRes.length) this.refreshDevicesTable(successRes.length)
        })
        .catch(error => {})
    },
    // 删除后刷新列表
    refreshDevicesTable(successCount) {
      if (this.tableData.length === successCount) {
        --this.pagination.current
      }
      this.getDevicesListData(this.pagination.current || 1)
    },
    // 删除设备的请求
    async getDeleteDeviceAxios(id) {
      try {
        const res = await deleteDevice({ id })
        deleteSelectedRow(id, this.selectedRowKeys, this.selectedRowItems)
        return Promise.resolve({ res: res, targetId: id })
      } catch (error) {
        return Promise.resolve({ res: error, targetId: id })
      }
    },

    // 打开添加设备模态框
    handleShowAddModal() {
      this.addDeviceModalVisible = true
      this.addModalTitleStr = new Function(
        'org',
        this.$t('devicesMana.addTips')
      )(this.modalDeviceDeptName)
      this.addDeviceForm = {
        SN: '',
        type: this.enumsData.deviceType[0].value,
        name: ''
      }
    },
    handleHideAddModal() {
      this.$refs.addDeviceForm.resetFields()
      this.confirmDeviceLoading = false
    },
    // 提交添加设备
    handleAddDevice(e) {
      this.$refs.addDeviceForm.validate(async valid => {
        if (valid) {
          try {
            this.confirmDeviceLoading = true
            await createDevice({
              deptId: this.targetOrg.id,
              deviceSn: this.addDeviceForm.SN,
              deviceTypeCode: this.addDeviceForm.type,
              deviceName: this.addDeviceForm.name
            })
            this.addDeviceModalVisible = false
            this.confirmDeviceLoading = false
            this.getDevicesListData()
          } catch (error) {
            this.confirmDeviceLoading = false
          }
        }
      })
    }
  }
}
</script>

<style scoped></style>
